// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1ClusterCondition } from './V1ClusterCondition';
import {
  V1ClusterConditionFromJSON,
  V1ClusterConditionFromJSONTyped,
  V1ClusterConditionToJSON,
  V1ClusterConditionToJSONTyped,
} from './V1ClusterCondition';

/**
 *
 * @export
 * @interface V1ClusterStatus
 */
export interface V1ClusterStatus {
  /**
   *
   * @type {Array<V1ClusterCondition>}
   * @memberof V1ClusterStatus
   */
  conditions?: Array<V1ClusterCondition>;
}

/**
 * Check if a given object implements the V1ClusterStatus interface.
 */
export function instanceOfV1ClusterStatus(
  value: object,
): value is V1ClusterStatus {
  return true;
}

export function V1ClusterStatusFromJSON(json: any): V1ClusterStatus {
  return V1ClusterStatusFromJSONTyped(json, false);
}

export function V1ClusterStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1ClusterStatus {
  if (json == null) {
    return json;
  }
  return {
    conditions:
      json['conditions'] == null
        ? undefined
        : (json['conditions'] as Array<any>).map(V1ClusterConditionFromJSON),
  };
}

export function V1ClusterStatusToJSON(json: any): V1ClusterStatus {
  return V1ClusterStatusToJSONTyped(json, false);
}

export function V1ClusterStatusToJSONTyped(
  value?: V1ClusterStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    conditions:
      value['conditions'] == null
        ? undefined
        : (value['conditions'] as Array<any>).map(V1ClusterConditionToJSON),
  };
}
